import { Field, Formik } from 'formik'
import React from 'react'

import type { SelectOption } from '@fourthwall/components'
import { Button, Fieldset, Select } from '@fourthwall/components'

import type { ConfigurationFormValues } from '../../AppsTiktokShop.types'
import { configurationFormValidationSchema } from '../../consts'

export type ConfigurationFormProps = {
  initialValues: ConfigurationFormValues
  shopOptions: SelectOption[]
  warehouseOptions?: SelectOption[]
  isLoading: boolean
  onShopSelect: (shopId: string) => void
  onSubmit: (values: ConfigurationFormValues) => void
}

export const ConfigurationForm = ({
  initialValues,
  shopOptions,
  warehouseOptions,
  isLoading,
  onShopSelect,
  onSubmit,
}: ConfigurationFormProps) => {
  return (
    <Formik<ConfigurationFormValues>
      initialValues={initialValues}
      validationSchema={configurationFormValidationSchema}
      enableReinitialize
      validateOnMount
      onSubmit={onSubmit}
    >
      {(formik) => (
        <form onSubmit={formik.handleSubmit}>
          <Fieldset>
            <Fieldset.Row>
              <Fieldset.Item>
                <Field
                  component={Select}
                  name="shopId"
                  options={shopOptions}
                  label="Select your TikTok Shop"
                  disabled={!shopOptions.length}
                  displayError={false}
                  onValueChange={onShopSelect}
                />
              </Fieldset.Item>
            </Fieldset.Row>
            {!formik.values.shopId ||
              (!!warehouseOptions?.length && warehouseOptions?.length > 0 && (
                <Fieldset.Row>
                  <Fieldset.Item>
                    <Field
                      component={Select}
                      name="warehouseId"
                      options={warehouseOptions}
                      label="Select warehouse"
                      displayError={false}
                    />
                  </Fieldset.Item>
                </Fieldset.Row>
              ))}
          </Fieldset>
          <div style={{ marginTop: 16 }}>
            <Button
              type="submit"
              label="Confirm selection"
              appearance="primary"
              disabled={!formik.isValid}
              loading={isLoading}
            />
          </div>
        </form>
      )}
    </Formik>
  )
}
